import { z } from "zod";

const envSchema = z.object({
	/** Absolute API origin; empty means same-origin (CloudFront proxies /api, Vite proxies it in dev/preview). */
	VITE_API_ORIGIN: z.string().default(""),
	MODE: z.string(),
	DEV: z.boolean(),
});

/** Validated once at startup so a misconfigured build fails loudly instead of at the first request. */
export const env = envSchema.parse(import.meta.env);
